module.exports = __webpack_public_path__ + "static/media/Tampa_Bay_Lightning.ca99c971.svg";